import React, {Component} from 'react';
import {fromPairs} from 'lodash';
import NanoEvent from 'nanoevents';
import {QUERY_BUILDER_TYPES} from '../utils/query_utils';

export const FEATURE_FLAGS_CONFIG = {
    QUERY_BUILDER_TYPE: {
        type: 'enum',
        defaultValue: QUERY_BUILDER_TYPES.COLUMN_FIRST,
        options: Object.values(QUERY_BUILDER_TYPES),
        name: 'Query builder type',
    },
    HIDE_DIMS_AND_FILTERS: {
        type: 'boolean',
        defaultValue: true,
        name: 'Hide dimensions and filters initially',
    },
    FOCUS_COLUMN_INPUT_ON_LOAD: {
        type: 'boolean',
        defaultValue: false,
        name: 'Focus column input on initial load',
    },
    SHOW_PREVIEW_TABLE: {
        type: 'boolean',
        defaultValue: true,
        name: 'Display preview table in column selector',
    },
    HIGHLIGHT_TABLE_VALUES: {
        type: 'boolean',
        defaultValue: false,
        name: 'Highlight entire table column on hover',
    },
    FILTERS_BESIDE: {
        type: 'boolean',
        defaultValue: true,
        name: 'Columns and filters side by side'
    },
    PRESELECT_COLUMNS: {
        type: 'boolean',
        defaultValue: false,
        name: 'Preselect columns',
    },
    SHOW_CHARTIO_SOURCE: {
        type: 'boolean',
        defaultValue: false,
        name: 'Show Chartio Datasource in source selector'
    },
    STEP_TRANSITION_DURATION: {
        type: 'number',
        defaultValue: 400,
        name: 'ms Step transition'
    },
    INCLUDE_META_COLUMNS: {
        type: 'boolean',
        defaultValue: true,
        name: 'Include Meta Columns under Table in Query Builder',
    },
    TABLE_MENU_SIDE: {
        type: 'boolean',
        defaultValue: true,
        name: 'Put the table menu on the right side',
    },
    // *** UNUSED ***
    // TABLE_SMOOTH_SCROLL: {
    //     type: 'boolean',
    //     defaultValue: true,
    //     name: 'Preview Table Smooth Scroll',
    // },
    // AGG_SHOW_DELAY: {
    //     type: 'number',
    //     defaultValue: 500,
    //     name: 'Aggregation Menu Show Delay',
    // },
    // AGG_HIDE_DELAY: {
    //     type: 'number',
    //     defaultValue: 200,
    //     name: 'Aggregation Menu Hide Delay',
    // },
    // COLUMN_MENU_AFTER_SEARCH: {
    //     type: 'boolean',
    //     defaultValue: false,
    //     name: 'Show column only after search',
    // },
    // SEPARATE_AGG_MENU: {
    //     type: 'boolean',
    //     defaultValue: true,
    //     name: 'Separate Aggregations List',
    // },
    // AUTO_ADVANCE_MENU: {
    //     type: 'boolean',
    //     defaultValue: false,
    //     name: 'Automatically Advance To Next Input',
    // },
};

const events = new NanoEvent();

export const FEATURE_FLAGS = fromPairs(Object.entries(FEATURE_FLAGS_CONFIG).map(([flag, {defaultValue}]) => [flag, defaultValue]));

export function setFeatureFlag(flag, value) {
    switch (FEATURE_FLAGS_CONFIG[flag].type) {
        case 'boolean':
            if (typeof value === 'string') {
                value = value === 'true';
            }
            break;
        case 'number':
            if (typeof value !== 'number') {
                value = parseInt(value, 10);
            }
            break;
        default:
            break;
    }
    FEATURE_FLAGS[flag] = value;
    events.emit(`${flag}_change`, value);
}

export function onFlagChange(flag, cb) {
    return events.on(`${flag}_change`, cb);
}

export function withFeatureFlag(flag, propName, ComponentToRender) {
    return class AddFeatureFlagProp extends Component {
        componentDidMount() {
            this.unbindFeatureFlagListener = onFlagChange(flag, () => { this.forceUpdate(); });
        }

        componentWillUnmount() {
            this.unbindFeatureFlagListener();
        }

        render() {
            const props = {
                [propName]: FEATURE_FLAGS[flag],
                ...this.props,
            };
            return <ComponentToRender {...props} />;
        }
    }
}
